export default __webpack_public_path__ + "static/media/ic-digital-library.3c4fd232.svg";